import { Event as RouterEvent, NavigationEnd, NavigationError, NavigationSkipped } from '@angular/router';
import { Observable } from 'rxjs';

/** Upper bound on how long the boot splash waits for the first route (a stuck guard must not trap anyone). */
export const BOOT_SPLASH_NAVIGATION_CAP_MS = 15_000;

/**
 * Resolves once the FIRST navigation has rendered a page (or failed), or after `capMs`.
 *
 * The auth guard exchanges the authorization code and loads the organizations before the first page
 * renders — a second or more after a redirect from the auth portal or a handoff from the mobile app.
 * Removing the splash before that left a blank page. A cancelled navigation does not count: a guard
 * redirect (UrlTree) is followed by another navigation that ends normally, and `bridge.login()`
 * cancels because the page is leaving for the auth portal — where the splash should stay up.
 */
export function firstNavigationSettled(
  events: Observable<RouterEvent>,
  capMs = BOOT_SPLASH_NAVIGATION_CAP_MS,
): Promise<void> {
  return new Promise<void>((resolve) => {
    const timer = setTimeout(done, capMs);
    const sub = events.subscribe((event) => {
      if (event instanceof NavigationEnd || event instanceof NavigationError || event instanceof NavigationSkipped) done();
    });
    function done(): void {
      clearTimeout(timer);
      sub.unsubscribe();
      resolve();
    }
  });
}
